module.exports = __webpack_public_path__ + "img/colored-rounded.275542c0.svg";